// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item[data-v-251be81d]{border:3pt solid #5e492a}.container-with-bg[data-v-251be81d]{background-color:transparent}.slider[data-v-251be81d]{max-width:400px}.voice-title[data-v-251be81d]{font-family:Bebas Neue;font-size:24px;line-height:29px}.voice-subtitle[data-v-251be81d],.voice-title[data-v-251be81d]{color:#fff;font-weight:400;letter-spacing:0;text-align:left;text-transform:uppercase}.voice-subtitle[data-v-251be81d]{font-family:Source Sans 3;font-size:14px;line-height:20px}", ""]);
// Exports
module.exports = exports;
